import { render, staticRenderFns } from "./LegalView.vue?vue&type=template&id=2d5216bd&scoped=true"
import script from "./LegalView.vue?vue&type=script&lang=js"
export * from "./LegalView.vue?vue&type=script&lang=js"
import style0 from "./LegalView.vue?vue&type=style&index=0&id=2d5216bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5216bd",
  null
  
)

export default component.exports